<template>
    <v-app-bar color="primary" :elevation="1">

        <v-progress-linear model-value="100" :active="routeLoading || routeError" :indeterminate="!routeError"
            :color="routeError ? 'error' : ''" absolute />

        <v-app-bar-nav-icon v-if="$vuetify.display.smAndDown" @click="$emit('update:toggleNavDrawer')" />
        <v-app-bar-title>
            <v-breadcrumbs :items="$route.meta.breadcrumbs" />
        </v-app-bar-title>
        <template v-slot:append>
            <div class="text-center">

                <AlertsMenu class="mr-3" :alerts="alerts"></AlertsMenu>

            </div>
        </template>
    </v-app-bar>
</template>

<script>
import { useUiStateStore } from '@/stores/uiState';

import AlertsMenu from '@/components/menus/AlertsMenu';

export default {
    name: 'AppBar',
    data() {
        return {
            uiState: null,
        }
    },
    props: {
        alerts: Array,
    },
    components: {
        AlertsMenu,
    },
    computed: {
        routeLoading() {
            return this.uiState.routeLoading;
        },
        routeError() {
            return this.uiState.routeError;
        },
    },
    created() {
        //Initialize the store
        this.uiState = useUiStateStore();
    },
}
</script>